module.exports = __webpack_public_path__ + "media/images/icon_login01_40-40-68bb85394fc190ec08622801f3d4c080.png";